import { useCallback } from 'react'
import { API, API_ROUTER } from '../../../../../api'
import { isAuthenticated } from '../../../../../helpers'
import usePaginatedData from '../../../../../hooks/usePaginatedData'

const useCommunityTournaments = (communityId) => {
  const fetchTournaments = useCallback(async ({ page, limit }) => {
    const endpoint = isAuthenticated()
      ? API_ROUTER.community.getCommunityTournamentsAuth
      : API_ROUTER.community.getCommunityTournaments

    const response = await API.request({
      ...endpoint,
      pathKeys: {
        communityId: communityId,
        page: page,
        limit: limit,
      },
    })

    return {
      data: response.tournaments,
      paginator: response.paginator
    }
  }, [communityId])

  return usePaginatedData({
    fetchFunction: fetchTournaments,
    dependencies: [communityId],
    limit: 10
  })
}

const useCommunityEvents = (communityId) => {
  const fetchEvents = useCallback(async ({ page, limit }) => {
    const endpoint = isAuthenticated()
      ? API_ROUTER.community.getCommunityEventAuth
      : API_ROUTER.community.getCommunityEvent

    const response = await API.request({
      ...endpoint,
      pathKeys: {
        communityId: communityId,
        page: page,
        limit: limit,
      },
    })

    return {
      data: response.events,
      paginator: response.paginator
    }
  }, [communityId])

  return usePaginatedData({
    fetchFunction: fetchEvents,
    dependencies: [communityId],
    limit: 10
  })
}

export { useCommunityTournaments, useCommunityEvents }
